import React from "react"
import cx from "classnames"
import { StaticImage } from "gatsby-plugin-image"

import { Detail, H1 } from "../../elements"

type HeroProps = {
  className?: string
}

const Hero = ({ className }: HeroProps) => {
  return (
    <div className={cx("overflow-hidden", className)}>
      <div className="flex relative max-w-screen-lg items-center mx-auto py-16 px-4">
        <div className="flex-1">
          <H1 className="text-left text-6xl AvenirLTProBlackOblique mb-4">
            Yurt Dışında Yaşayan{" "}
            <span className="text-purple">Gerçek Kişilerin</span> Hikayeleri
          </H1>
          <Detail className="text-left text-lg text-gray-dark font-bold leading-7">
            Yurt dışında yaşamak isteyen kişilere fikir verebilelim diye, yurt
            dışında yaşayan kişilerle röportaj yapıp, sizlere somut bilgiler
            sunabilmek için Çizzgi’yi hazırladık.
          </Detail>
        </div>

        <div className="flex-1 relative hidden sm:block">
          <div className="absolute left-0">
            <StaticImage
              src="../../../images/polaroid.png"
              alt="polaroid"
              placeholder="none"
              width={749}
              style={{
                minWidth: "749px",
                top: "-148px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
